module.exports = require('react/lib/ReactTransitionGroup');


//////////////////
// WEBPACK FOOTER
// ../~/react-addons-transition-group/index.js
// module id = 536
// module chunks = 0